var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filled/CloudUpload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "IconVector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.75 47.25V63C33.75 64.2426 34.7574 65.25 36 65.25C37.2426 65.25 38.25 64.2426 38.25 63V47.25H48C57.0324 47.25 65.25 41.3126 65.25 33C65.25 26.131 59.5827 20.8545 52.5898 19.2592C50.5293 12.0374 43.8843 6.75 36 6.75C28.1157 6.75 21.4707 12.0374 19.4102 19.2592C12.4173 20.8545 6.75 26.131 6.75 33C6.75 41.3126 14.9676 47.25 24 47.25H33.75ZM46.5261 33.6544L37.5261 25.3467C36.6642 24.5511 35.3358 24.5511 34.4739 25.3467L25.4739 33.6544C24.5608 34.4972 24.5038 35.9207 25.3467 36.8338C26.1896 37.7469 27.613 37.8039 28.5261 36.961L33.75 32.139V45C33.75 46.2426 34.7574 47.25 36 47.25C37.2426 47.25 38.25 46.2426 38.25 45V32.139L43.4739 36.961C44.387 37.8039 45.8104 37.7469 46.6533 36.8338C47.4962 35.9207 47.4392 34.4972 46.5261 33.6544Z",
    fill: "#033272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/CloudUpload.a5c69fb6842e6b0aa9f936ad0084d7f1.svg";
export { ForwardRef as ReactComponent };